export default __webpack_public_path__ + "static/media/Group 3026@2x.6b4f637f.png";